import { QuotasSelector } from "./components";

export const StepOne = () => <QuotasSelector />

